module.exports = __webpack_public_path__ + "img/bom7.23e1c62a.png";